// @flow

import memoize from 'lodash.memoize';

import {CLASS_PROPERTIES} from '../constants';

import type {PropertyClasses} from '../typedef';


const propertyClasses = (classes: PropertyClasses): string => {

    const properties = Object.keys(CLASS_PROPERTIES).filter(property => {
        return Boolean(Object.keys(classes).find(c => c === property));
    });

    return properties.reduce((prev, key) => (
        prev + (!!classes[key] && `-${CLASS_PROPERTIES[key]}` || '')
    ), '');
};

export const getPropertyClasses: (classes: PropertyClasses) => string =
    memoize<Array<PropertyClasses>, string>(propertyClasses);

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
